import { render } from "./BaseAlert.vue?vue&type=template&id=31affb06"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src407097413/src/Abbott-Seguimiento-Email-Backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__